import { useStore } from '@tanstack/react-store';
import { chatStore } from '@/store/ai-chat.store';

export function useChatStore() {
  return useStore(chatStore);
}

export function useActiveMessages() {
  const { activeThreadId, messages } = useStore(chatStore);
  const threadId = activeThreadId ?? 'new';
  return messages[threadId] ?? [];
}

export function useFilteredThreads() {
  const { threads, threadFilter, threadSearch } = useStore(chatStore);
  return threads.filter(t => {
    const matchesFilter = threadFilter === 'all' || t.category === threadFilter;
    const matchesSearch =
      !threadSearch ||
      t.title.toLowerCase().includes(threadSearch.toLowerCase()) ||
      t.tags.some(tag => tag.toLowerCase().includes(threadSearch.toLowerCase()));
    return matchesFilter && matchesSearch;
  });
}

export function usePinnedThreads() {
  const { threads } = useStore(chatStore);
  return threads.filter(t => t.pinned);
}

export function useActiveThread() {
  const { threads, activeThreadId } = useStore(chatStore);
  return threads.find(t => t.id === activeThreadId) ?? null;
}